'use client'

import React from 'react'
import { trackEvent } from '@acko-tech/building-blocks.ui.acko-analytics'
import { FUEL_TAP_EVENTS } from '@constants/fuelEvents'
import { fuelSegmentEventCommonPropFunc } from '@utils/segmentProperties'
import styles from './floaterDownloadAckoApp.module.scss'
import HideOnApp from './floaterUtils'

const FloaterDownloadAckoApp = () => {
  const handleAppStore = async (eventName, redirectionUrl) => {
    const fuelSegmentCommonProperties = await fuelSegmentEventCommonPropFunc()
    await trackEvent(eventName, {
      ...fuelSegmentCommonProperties,
    })
      .then(() => {})
      .catch(err => {
        console.error(err)
      })
      .finally(() => {
        window.open(redirectionUrl, '_blank')
      })
  }

  return (
    <div className={styles.floaterFuelWrapper}>
      <div
        className={styles.downloadAppAnchorTag}
        onClick={e => {
          e.preventDefault()
          void handleAppStore(FUEL_TAP_EVENTS.TAP_ACKO_APP_FLOATER, 'https://ackoapp.onelink.me/TnnH/r37o8k0s')
        }}>
        Get ACKO app
      </div>
    </div>
  )
}

export default HideOnApp(FloaterDownloadAckoApp)
